import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const DataIntegratorModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth40 = '40px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Integrador_de_dados" data-name="Integrador de dados">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M585.47,611.59C662.07,525.25,771,222.19,693.06,128,591,4.64,435,126.37,317.3,161.82-182.45,312.36,296,937.82,585.47,611.59Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M563.54,612.38c26.49,27.3,66.65,39.57,105.74,28,52.23-15.5,84.2-69.5,73.08-123.46-.07-.36-.15-.72-.23-1.08a103.23,103.23,0,0,1,.66-45.37,64.37,64.37,0,0,0-1-33.05c-9.79-33-44.29-52.5-77.17-43.7-12.74,3.4-37.27,21-55.82,34.81-12.51,9.33-24.33,13.34-39.07,8.13-16.76-5.92-47.9,1.6-61,20.34C484,492.1,487,504,495.13,546.58c3.65,19.12.55,44,38.37,44.93C543.76,591.76,556.34,605,563.54,612.38Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M246.83,153.51c-32.32-16.68-73.63-15.54-107.65,7-45.45,30-61.54,88.82-36.76,134.4.16.31.33.61.5.91a93,93,0,0,1,11.33,41.39,57.62,57.62,0,0,0,9.68,29.68c18,27,55.84,34.12,84.7,16.08,11.19-7,29.82-30.45,43.77-48.67C261.8,322,272,314.7,287.31,314.92c17.45.26,45-16.09,52.52-37.11,14.1-39.43,8.18-49.28-10.78-85.49-8.5-16.24-12.12-39.8-48.23-29.06C271,166.18,255.61,158.05,246.83,153.51Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M724.1,373.78c26.91-26.89,38.57-67.23,26.38-106.14-16.27-52-70.74-83.16-124.53-71.23l-1.08.24a103.22,103.22,0,0,1-45.37,0,64.25,64.25,0,0,0-33,1.51c-32.85,10.29-51.84,45.07-42.55,77.81,3.59,12.69,21.54,37,35.64,55.3,9.51,12.37,13.7,24.13,8.71,38.95-5.67,16.84,2.32,47.87,21.24,60.72,35.51,24.11,47.31,21,89.82,12.2,19.06-3.93,44-1.2,44.36-39C703.78,393.87,716.79,381.09,724.1,373.78Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M754,311.62C769.15,342,755.79,390.68,750,403c-25.88,55.53-75,171.86-222.12,225.07-180,65.13-248.65,13.21-271-1.27C238.75,615.09,137.41,492,135.76,399.1s5.05-110.83,46.19-174c20.66-31.7,84.31-72.9,105.76-69.8C362.79,166.16,479.29,276.1,551.5,255.6c107.52-30.53,146.36,7.89,174,22.61C740.2,286.07,745.12,293.93,754,311.62Z"
              />
              <path
                fill={fillColor600}
                d="M49.05,597.12A31.79,31.79,0,0,0,64,632.29C76.6,639.65,92.5,649,96.39,648.38c18-3-10.33-74.16-20.55-81.53C64.23,558.48,53.84,578.26,49.05,597.12Z"
              />
              <path
                fill={fillColor600}
                d="M151.2,109.6c-16.65.63-29.87,29.41-19.12,37.49,12.64,7.82,30.7-14,41.73-26.68C175.6,113,163.18,109.44,151.2,109.6Z"
              />
              <path
                fill={fillColor600}
                d="M602.91,670.17c14.68-9.67,39,1.39,48.71,16.07s1,27.43-13.69,37.1-47.86,14.46-57.53-.22S588.23,679.84,602.91,670.17Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M596.29,627.86h0a48.41,48.41,0,0,1-48.42-48.42h0A48.4,48.4,0,0,1,596.29,531h0a48.41,48.41,0,0,1,48.43,48.42h0A48.41,48.41,0,0,1,596.29,627.86Z"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M426.82,385.75V531"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M426.82,627.86h0a48.41,48.41,0,0,1-48.43-48.42h0A48.41,48.41,0,0,1,426.82,531h0a48.4,48.4,0,0,1,48.42,48.42h0A48.41,48.41,0,0,1,426.82,627.86Z"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M257.34,627.86h0a48.41,48.41,0,0,1-48.42-48.42h0A48.4,48.4,0,0,1,257.34,531h0a48.4,48.4,0,0,1,48.42,48.42h0A48.41,48.41,0,0,1,257.34,627.86Z"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M257.34,531V490.35c0-11.23,10.85-20.34,24.21-20.34H572.08c13.37,0,24.21,9.11,24.21,20.34V531"
            />
            <path
              fill={fillBG}
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M257.34,228.38c0-33.44,75.88-60.53,169.48-60.53s169.47,27.09,169.47,60.53v96.84c0,33.44-75.87,60.53-169.47,60.53s-169.48-27.09-169.48-60.53Z"
            />
            <path
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M596.29,228.38c0,33.43-75.87,60.52-169.47,60.52s-169.48-27.09-169.48-60.52"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(DataIntegratorModuleBrand)
